import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Nav, Offcanvas, Row, Tab, Tabs } from "react-bootstrap";
import { BsFloppy, BsInfoCircle, BsJournalText } from "react-icons/bs";
import { ShortNamesOfTestCategories } from "../../reuse/ShortNamesOfTestCategories";
import { auditTypes } from "../../../constants/auditTypes";
import { saveAnswer } from "./saveAnswer";
import { useParams } from "react-router";
import { saveAuditResult } from "./saveAuditResult";
import { answerVisual } from "../../../constants/right_answer";
import Clock from "../../reuse/Clock";


const TaskFullInfo = ({task, data}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return(
        <>
            <BsInfoCircle className="icon_button_infoTask" onClick={handleShow}/>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header className="text_font" closeButton>Пункт {task} - номер {data.additional_info.index}</Modal.Header>
                <Modal.Body className="text_font">
                    <p className="sepatate_text"><strong>Условие: </strong>{data.task_value}</p>
                    <p className="sepatate_text"><strong>Контрольный элемент: </strong>{data.control_element}</p>
                    <p><strong>Ответственный: </strong>{data.additional_info.accountable}</p>
                    <Row className="d-flex justify-content-center flex-wrap">
                        <Col md={6}>
                        <Button className="free-btn" onClick={handleClose}>Закрыть</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal> 
        </>
    )
}

const TasksBlocks = ({partName, categoryName, level,task, data}) => {
    const [SelectResult, setSelectResult] = useState(data.result);
    const [CommentResult, setCommentResult] = useState(data.comment);
    const {audit_id}=useParams();

    const [positiveBtn, setPositiveBtn]=useState("m-1 btn-light")
    const [negativeBtn, setNegativeBtn]=useState("m-1 btn-light")

    const answersLabels = {[null]:"Ничего",[true]:"1.Да",[false]:"0.Нет"}

    const handleSaveAnswer = (value) => {
        // console.log(partName, categoryName, level, task, value)
        setSelectResult(value)
        const data_send ={
            part_name:partName,
            category:categoryName,
            level:level, 
            task_number:task, 
            result:value
        }
        // // console.log(data_send)
        saveAnswer(audit_id, data_send)
    }

    const handleSaveComment = (value) => {
        const data_send ={
            part_name:partName,
            category:categoryName,
            level:level, 
            task_number:task, 
            comment:value.trim()
        }
        // // console.log(data_send)
        saveAnswer(audit_id, data_send)
    } 

    useEffect(()=>{
        switch(SelectResult){
            case false :
                setPositiveBtn("m-1 btn-light");
                setNegativeBtn("m-1 btn-danger chose_btn");
                break
            case true :
                setPositiveBtn("m-1 btn-success chose_btn");
                setNegativeBtn("m-1 btn-light");
                break
            default:
                return  
        }
    },[SelectResult])
    return(
        <>
        <Card className="mt-2 mb-2">
            <Card.Body>
                <div className="d-flex justify-content-between align-items-baselign">
                    <p className="text_font">Пункт {task}. {data.task_value}</p>
                    <div>
                        <TaskFullInfo task={task} data={data}/>
                    </div>
                </div>
                <div>
                    {/* {JSON.stringify(data)} */}
                    <div className="d-flex justify-content-between align-items-baseline flex-wrap">
                        <div className="d-flex align-items-baseline gap-3">
                            <Button 
                            size="md"
                            onClick={()=>handleSaveAnswer(true)}
                            className={positiveBtn}>1.Да</Button>
                            <Button 
                            size="md"
                            onClick={()=>handleSaveAnswer(false)}
                            className={negativeBtn}>0.Нет</Button>
                        </div>
                        {data.esteem_result!==null ? <div className="d-flex align-items-baseline">
                            <div className="text_font">Caмооценка:</div>
                            <div>
                            <Button 
                            size="md"
                            className={data.esteem_result ? "m-1 btn-success chose_btn" : "m-1 btn-danger chose_btn"}>{answerVisual[data.esteem_result]}</Button>
                            </div>
                        </div> : null}
                    </div>
                    <div>
                        <Form.Control 
                        id={`${partName}-${categoryName}-${level}-${task}-comment`}
                        as="textarea" 
                        cols={2} 
                        value={CommentResult || ''}
                        onChange={(e) => setCommentResult(e.target.value)}
                        onBlur={(e)=>handleSaveComment(e.target.value)}
                        placeholder="Введите комментарий..."></Form.Control>
                    </div>
                </div>
            </Card.Body>
        </Card>
        </>
    )
}

const LevelsBlocks = ({partName, categoryName, level,  data}) => {
    const tasks=Object.keys(data);
    return(
        <>
        <div className="mt-1 mb-1">
            <h5>Уровень {level}</h5>
        </div>
        {tasks.map((task)=>{
            return <TasksBlocks 
            partName={partName} 
            categoryName={categoryName} 
            level={level}
            task={task}
            data={data[task]}
            />
        })}
        </>
    )
    
}

const CategoryNamesBlocks = ({partName, categoryName, data, shortNames}) => {
    const levels=Object.keys(data);
    
    return(
        <>
        <div className="mt-2 mb-2" id={`${partName}-${categoryName}`}>
        <Card>
            <Card.Header className="d-flex align-items-baseline">
                <div className="d-flex align-items-center" gap-1>
                    <div className="custom_badge_primary bage_params m-1">{shortNames[partName][categoryName]}</div>
                    <div className="text_font">{categoryName}</div>
                    </div>
                </Card.Header>
            <Card.Body>
                <Tabs 
                variant="pills"
                defaultActiveKey={levels[0]}
                className="custom-tabs" 
                fill>
                    {levels.map((level)=>{
                        return <Tab 
                        key={level} 
                        eventKey={level} 
                        title={`Уровень ${level}`}>
                            <LevelsBlocks 
                            partName={partName}
                            categoryName={categoryName}
                            level={level}
                            data={data[level]}/>
                        </Tab>
                    })}
                </Tabs>
            </Card.Body>
        </Card>
        </div>  
        </>
    )
}

const PartNamesBlocks = ({partName, data, shortNames}) => {
    const categoryNames=Object.keys(data);
    return(
        <>
        <h4 className="mt-2 mb-2" id={`${partName}`}>{partName}</h4>
        {categoryNames.map((categoryName)=>{
            return <CategoryNamesBlocks 
            partName={partName} 
            categoryName={categoryName} 
            data={data[categoryName]} 
            shortNames={shortNames}/>
        })}
        </>
    )
}

const TestStructure = ({dataTest, shortNames}) => {
    const partNames=Object.keys(dataTest);
    return(<>
    {partNames.map((partName)=>{
        return <PartNamesBlocks partName={partName} data={dataTest[partName]} shortNames={shortNames}/>
    })}
    </>)
}

const ModalInfo = ({data}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const showFields=["name","description","audit_type",
        "start_datetime","end_datetime","audit_leader",
        "test_name","facility_name"]
    const fieldsLabel={
        "name":"Название",
        "description":"Описание",
        "facility_name":"Завод",
        "audit_type":"Тип",
        "start_datetime":"Дата начала",
        "end_datetime":"Дата окончания",
        "audit_leader":"Логин лидера аудита",
        "test_name":"Название теста"
    }
    return(
        <>
        <div onClick={handleShow} className="d-flex gap-2 flex-wrap align-items-center audit_info_label_block text_font">
            <BsInfoCircle /> 
            <div>Информация об аудите</div>
        </div>
        <Modal show={show} onHide={handleClose} size="md">
            <Modal.Header closeButton>
            <Modal.Title className="text_font">Информация об аудите</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text_font">
                {showFields.map((elem)=>{
                    if(elem=="start_datetime" || elem=="end_datetime"){
                        return(
                            <div>
                            <span><strong>{fieldsLabel[elem]}: </strong>{new Date(data[elem]).toLocaleString()}</span>
                            </div>
                        )
                    }
                    if(elem=="audit_type"){
                        return(
                            <div>
                            <span><strong>{fieldsLabel[elem]}: </strong>{auditTypes[data[elem]]}</span>
                            </div>
                        )
                    }
                    return(
                        <div>
                        <span><strong>{fieldsLabel[elem]}: </strong>{data[elem]}</span>
                        </div>
                    )
                })}
                {/* <p>{Object.keys(data).map((elem)=>{return(<p>{JSON.stringify(elem)}</p>)})}</p> */}
            </Modal.Body>
        </Modal>
        </>
    )
}

const ModalMenu = ({ data }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleScrollTo = (id) => (e) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    handleClose(); // закрыть оффканвас после прокрутки
  };

  return (
    <>
      <BsJournalText className="icon_button_menu m-1" onClick={handleShow} />
      <Offcanvas show={show} onHide={handleClose} className="menu_audit_structure" placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="text_font">Меню</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="text_font">
            <li>
              <Nav.Link className="link_menu_partNames" onClick={handleScrollTo('info_card')}>
                Начало
              </Nav.Link>
            </li>
            {Object.keys(data).map((partName) => (
              <li key={partName}>
                <Nav.Link
                  className="link_menu_partNames"
                  onClick={handleScrollTo(partName)}
                >
                  {partName}
                </Nav.Link>
                <div>
                  {Object.keys(data[partName]).map((category) => (
                    <div className="mb-2" key={category}>
                      <Nav.Link
                        className="link_menu_category text_font"
                        onClick={handleScrollTo(`${partName}-${category}`)}
                      >
						<div>{data[partName][category]} {category}</div>
                      </Nav.Link>
                    </div>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

const getMenuLinks = (data,shortNames) => {
    const menuValues={}
    Object.keys(data.data).forEach((partName)=>{
        const categoriesShortNames={}
        Object.keys(data.data[partName]).forEach((categoryName)=>{
            categoriesShortNames[categoryName]=shortNames[partName][categoryName]
        })
        menuValues[partName]=categoriesShortNames;
    })
    return(menuValues)
}

const AuditShortInfo = ({data}) => {
    return(
        <Card className="mt-2 mb-2">
            <Card.Header>
                <div className="d-flex align-items-center flex-wrap gap-2">
                    <ModalInfo data={data}/>
                </div>
			</Card.Header>
            <Card.Body className="text_font">
                {/* <h4><Clock/></h4> */}
                <div><strong>Название: </strong>{data.name}</div>
                <div><strong>Тип: </strong>{auditTypes[data.audit_type]} | <strong>Завод: </strong>{data.facility_name}</div>
                <div><strong>Время начала и окончания: </strong></div>
                <div>{new Date(data.start_datetime).toLocaleString()} - {new Date(data.end_datetime).toLocaleString()}</div>
            </Card.Body>
        </Card>
    )
}



const AuditInterface = ({data}) => {
    const shortNames=ShortNamesOfTestCategories(data.data);
    const menuValues=getMenuLinks(data, shortNames);

    const {audit_id}=useParams();
    const handleSave = () => {
        saveAuditResult(audit_id);
    }

    return(
        <>
        <div className="block_buttons_page_audit">
        <div className="main_buttons_block">
            <div className="d-flex flex-column">
                <ModalMenu data={menuValues}/>
                <BsFloppy className="icon_button_menu m-1" onClick={()=>handleSave()}/>
            </div>
        </div>
        </div>
        <div>
            <div id="info_card">
            <AuditShortInfo data={data}/>
            </div>
            <TestStructure dataTest={data.data} shortNames={shortNames}/>
        </div>
        </>
    )
}

export default AuditInterface;